/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useData1 } from "../data/useData1";
import { useChart2 } from "../transformers/useChart2";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { Table, TableProps } from "../../../components/Table";
import { ComponentContextReadyState } from "@sa/rep-core";
import { SERIES_AXIS, CATEGORIES_AXIS } from "../constants";

export const ComponentChart2: React.FC<{ context: ContextReport1 }> = (props) => {
  const context = props.context;
  const orderedCountriesIds = useHookSubscribe(null, context.orderedCountriesIds$);
  const olapCountriesConsumtion = useHookSubscribe(null, context.olapCountriesConsumtion$);
  const highlightData = useHookSubscribe(null, context.highlightData);
  const data = useData1(olapCountriesConsumtion);
  const tableData = useChart2(data, orderedCountriesIds);

  const getRowClass = React.useCallback(
    (params: any) => {
      let rowClass = "";
      if (
        highlightData &&
        highlightData.highlightType === "row" &&
        params.data.rawPeriod === highlightData[`${SERIES_AXIS}.name`]
      ) {
        rowClass = "row_highlight";
      }
      return rowClass;
    },
    [highlightData],
  );

  const getCellClass = React.useCallback(
    (params: any) => {
      let cellClass = "";
      if (
        highlightData &&
        highlightData.highlightType === "cell" &&
        params.data.rawPeriod === highlightData[`${SERIES_AXIS}.name`] &&
        params.colDef.headerName === highlightData[`${CATEGORIES_AXIS}.name`]
      ) {
        cellClass = "cell_highlight";
      }
      return cellClass;
    },
    [highlightData],
  );

  const table = React.useMemo(
    () => (tableData ? <Table {...tableData} getRowClass={getRowClass} getCellClass={getCellClass} /> : null),
    [tableData, getRowClass, getCellClass],
  );
  if (window['exportMode']) {
    window["exportReady"] = table && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!window["exportMode"] && (!table || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>Consumption per capita (kg/person)</ComponentTitle>
      <ComponentSourcetitle> </ComponentSourcetitle>
      {table}
    </>
  );
};
